// import React, { useState, useEffect } from 'react';
// import {
//   Tabs,
//   TabList,
//   Tab,
//   TabPanels,
//   TabPanel,
//   Table,
//   Thead,
//   Tbody,
//   Tr,
//   Th,
//   Td,
//   TableContainer,
//   Checkbox,
//   Button,
//   Spinner,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalBody,
//   ModalCloseButton,
//   ModalFooter,
// } from '@chakra-ui/react';
// import { Plus, SquarePen, Trash2 } from 'lucide-react';
// import { toast } from 'react-toastify';
// import Pagination from '../../../utils/pagination/Pagination';
// import ReactHTMLTableToExcel from 'react-html-table-to-excel';
// import { SolarInverterForm } from './SolarInverterForm'; // Ensure this path is correct
// import { SolarBrandForm } from './SolarBrandForm'; // Ensure this path is correct
// import PanelList from '../panel/PanelList';
// import { deleteSolarBrand } from '../../../redux/api/solarBrandApi/SolarbrandApi.js';
// import { getSolarBrand } from '../../../redux/reduxApi/SolarBrandReduxApi';
// import { deleteSolarBrandAction } from '../../../redux/reduxSlice/SolarBrandSlice.js';
// import { getSolarInverter } from '../../../redux/reduxApi/solarInverterReduxApi.js';
// import { useSelector, useDispatch } from 'react-redux';
// import InverterList from './InverterList.js';
// import { formatDate } from '../../../utils/commonFunction/CommonFunction.js';
// export default function SolarBrand() {
//   const [isSolarInverter, setIsSolarInverter] = useState(false);
//   const [isSolarBrand, setIsSolarBrand] = useState(false);
//   const [isOpen, setIsOpen] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(5);
//   const [solarData, setSolarData] = useState([]);
//   const [inverterData, setInverterData] = useState([]);
//   const [data, setData] = useState([]);
//   const [isLoading, setLoading] = useState(false);
//   const [itemId, setItemId] = useState("");
//   const [dataToEdit, setDataToEdit] = useState({});
//   const [isUpdateMode, setIsUpdateMode] = useState(false);
//   const [deleteId, setDeleteId] = useState("");
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [showProgressBar, setShowProgressBar] = useState(false);
//   const [totalCount, setTotalCount] = useState(0);
//   const solarbrandData = useSelector((state) => state.solarBrand.solarBrand);
//   const inverterbrandData = useSelector((state) => state.solarInverter.solarInverter);
//   const dispatch = useDispatch();
//   const [deleteSolarBrandROWID, setDeleteSolarBrandROWID] = useState("");

//   const [itemsPerPage, setItemsPerPage] = useState(30);


//   //for display the inverter data
//   useEffect(() => {
//     if (inverterbrandData && inverterbrandData.length > 0) {
//       setInverterData(inverterbrandData);
//     }
//   }, [inverterbrandData]);


//   useEffect(() => {
//     const page = 1;
//     // setLoading(true);
//     dispatch(getSolarInverter(page)).then((response) => {
//       setLoading(false);
//     }).catch((error) => {
//       console.log(error)
//     }).finally(() => {
//       setLoading(false)
//       setTimeout(() => {
//       }, [300])
//     })
//   }, [])
//   //for display the data
//   useEffect(() => {
//     if (solarbrandData && solarbrandData.length > 0) {
//       setSolarData(solarbrandData);
//     }
//   }, [solarbrandData]);

//   useEffect(() => {
//     const page = 1;
//     // setLoading(true);
//     dispatch(getSolarBrand(page)).then((response) => {
//       setLoading(false);
//     }).catch((error) => {
//       console.log(error)
//     }).finally(() => {
//       setLoading(false)
//       setTimeout(() => {
//       }, [300])
//     })
//   }, [])
//   useEffect(() => {
//     const page = 1;
//     // setLoading(true);
//     dispatch(getSolarInverter(page)).then((response) => {
//       setLoading(false);
//     }).catch((error) => {
//       console.log(error)
//     }).finally(() => {
//       setLoading(false)
//       setTimeout(() => {
//       }, [300])
//     })
//   }, [])
//   // For Trash modal
//   const openTrash = () => {
//     setIsOpen(true);
//   };

//   const closeTrash = () => {
//     setIsOpen(false);
//   };

//   const openSolarInverterDrawer = () => {
//     setIsSolarInverter(true);
//     setIsUpdateMode(false); // Ensure update mode is off when creating a new item
//     setDataToEdit({}); // Clear any existing data to edit
//   };

//   const closeSolarInverter = () => {
//     setIsSolarInverter(false);
//   };
//   const openSolarBrandDrawer = () => {
//     setIsSolarBrand(true);
//     setIsUpdateMode(false); // Ensure update mode is off when creating a new item
//     setDataToEdit({}); // r any existing data to edit
//   };

//   const closeSolarBrand = () => {
//     setIsSolarBrand(false);
//   };

//   const handleDelete = () => {
//     setShowProgressBar(true);
//     setLoading(true);
//     const idsToDelete =
//       selectedRows.length === 0 ? [deleteSolarBrandROWID] : selectedRows;
//     Promise.all(idsToDelete.map((id) => deleteSolarBrand(id)))
//       .then(() => {
//         setData((prevData) =>
//           prevData.filter((item) => !idsToDelete.includes(item?.ROWID))
//         );
//         dispatch(deleteSolarBrandAction(idsToDelete));
//         // fetchTotalCount()
//         toast.success("Row Deleted successfully");
//         // fetchTotalCount()

//       })
//       .catch((error) => {
//         console.log(error);
//         toast.error("Row not deleted");
//       })
//       .finally(() => {
//         setShowProgressBar(false);
//         setLoading(false);
//         closeTrash();
//         setSelectedRows([]);
//         setDeleteSolarBrandROWID("")
//       });

//   };


//   // Single Select
//   const handleRowSelect = (ROWID) => {
//     const isSelected = selectedRows.includes(ROWID);
//     let newSelectedRows = [];
//     if (!isSelected) {
//       newSelectedRows = [...selectedRows, ROWID];
//     } else {
//       newSelectedRows = selectedRows.filter(rowItem => rowItem !== ROWID);
//     }
//     setSelectedRows(newSelectedRows);
//     setDeleteId(newSelectedRows.join(','));
//   };

//   // All Select
//   const handleSelectAllRows = () => {
//     const allSelected = selectedRows.length === solarData.length;
//     let newSelectedRows = [];
//     if (!allSelected) {
//       newSelectedRows = solarData.map(item => item?.rowId);
//     }
//     setSelectedRows(newSelectedRows);
//   };

//   return (
//     <>
//       {isLoading && (
//         <div className="spinner-overlay">
//           <Spinner size="xl" color="purple.500" />
//         </div>
//       )}
//       <Modal isOpen={isOpen} onClose={closeTrash}>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>Are you sure you want to Delete?</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             {/* Optional body content */}
//           </ModalBody>
//           <ModalFooter>
//             <Button className='create-button' mr={3} onClick={handleDelete}>
//               Delete
//             </Button>
//             <Button className='cancel-button' onClick={closeTrash}>Cancel</Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>
//       <Tabs variant="enclosed">
//         <TabList>
//           <Tab _selected={{ color: 'black', bg: '#C7E9FF', border: "2px solid #AED2EA" }}>Solar Panel Brand </Tab>
//           {/* <Tab _selected={{ color: 'black', bg: '#C7E9FF', border: "2px solid #AED2EA" }}>Panel</Tab> */}
//           <Tab _selected={{ color: 'black', bg: '#C7E9FF', border: "2px solid #AED2EA" }}>Inverter Brand</Tab>
//         </TabList>
//         <TabPanels>
//           <TabPanel>
//             <div className="d-flex justify-content-end">
//               <button className="new-button mx-2" onClick={openSolarBrandDrawer}>
//                 <Plus size="18px" />
//                 <span className="ms-1">New</span>
//               </button>
//             </div>
//             <div className="custom-scroll leadListConatainer"  style={{ maxHeight: "72vh",width:"100%", position: "relative", overflowY: "scroll" ,overflowX:'hidden', scrollbarColor: '#A0AEC0 #EDF2F7',
//     scrollbarWidth: '10px'  }}>
//               <TableContainer className='card card-detail mt-1'>
//                 <ReactHTMLTableToExcel
//                   id="test-table-xls-button"
//                   className="download-table-xls-button d-none"
//                   table="table-to-xls"
//                   filename="SolarBrand List"
//                   sheet="tablexls"
//                   buttonText="Export"
//                 />
//                 <Table id="table-to-xls" className='leadNoPadding' variant='simple' size='sm' stickyHeader style={{ whiteSpace: 'nowrap', backgroundColor: 'white' }}>
//                   <Thead>
//                     <Tr className="tr-border">
//                       <Th className='py-1 th-color' style={{ width: '50px' }}>
//                         <Checkbox isChecked={selectedRows?.length === data?.length} onChange={handleSelectAllRows} />
//                       </Th>
//                       <Th className='py-1 th-color sticky-column' style={{ width: '80px' }}>Actions</Th>
//                       <Th className='py-1 th-color' style={{ width: '150px' }}>Solar Panel Brand Name</Th>
//                       <Th className='py-1 th-color' style={{ width: '150px' }}>Solar Panel Brand Description</Th>
//                       <Th className='py-1 th-color sticky-column' style={{ width: '80px' }}>Created Time</Th>
//                       <Th className='py-1 th-color sticky-column' style={{ width: '80px' }}>Modified Time</Th>
//                       <Th className='py-1 th-color sticky-column' style={{ width: '80px' }}>Created By</Th>
//                     </Tr>
//                   </Thead>
//                   <Tbody>
//                     {solarData && solarData.slice((currentPage - 1) * 30, currentPage * 30).map((item, idx) => (
//                       <Tr className='tr-border' key={idx}>
//                         <Td className='font-colors py-1'>
//                           <Checkbox isChecked={selectedRows.includes(item.rowId)} onChange={() => handleRowSelect(item.rowId)} />
//                         </Td>
//                         <Td className='d-flex' style={{ borderBottom: 'none' }}>
//                           <SquarePen color="#ff176b" size="16px" strokeWidth="1" className='mx-1' onClick={() => { openSolarBrandDrawer(); setDataToEdit(item); setIsUpdateMode(true); setItemId(item?.rowId); }} />
//                           <Trash2 color="#ff176b" size="16px" strokeWidth="1" onClick={(e) => { openTrash(e); console.log("itemm", item); setDeleteSolarBrandROWID(item?.ROWID); }} />
//                         </Td>
//                         <Td className='font-colors py-1'>{item?.solarBrandName}</Td>
//                         <Td className='font-colors py-1'>{item?.solarBrandDescription}</Td>
//                         <Td className='font-colors py-1'>{formatDate(item?.CREATEDTIME)}</Td>
//                         <Td className='font-colors py-1'>{formatDate(item?.MODIFIEDTIME)}</Td>
//                         <Td className='font-colors py-1'>{item?.createdBy || '-'}</Td>
//                       </Tr>
//                     ))}
//                   </Tbody>
//                 </Table>
//               </TableContainer>
//             </div>
//             <div className="footer d-flex fixed-bottom start-20">
//               <div className="total" style={{ marginLeft: "20%", marginTop: "15px" }}>
//                 <p className="fw-semibold">Total Count: {solarData.length}</p>
//               </div>
//               {/* Pagination */}
//               <div className="d-flex align-items-center justify-content-center position-fixed-bottom mx-auto">
//                 <Pagination
//                   totalPages={Math.ceil(solarData.length / itemsPerPage)}
//                   onPageChange={(no) => setCurrentPage(no)}
//                 />
//               </div>
//             </div>
//             <SolarBrandForm
//               isSolarBrand={isSolarBrand}
//               closeSolarBrand={closeSolarBrand}
//               dataToEdit={dataToEdit}
//               isUpdateMode={isUpdateMode}
//               setIsUpdateMode={setIsUpdateMode}
//               solarInverterId={itemId}
//             />
//           </TabPanel>

//           {/* <TabPanel>
//             <PanelList />
//           </TabPanel> */}


//           <TabPanel>
//             <InverterList />
//           </TabPanel>
//         </TabPanels>
//       </Tabs>
//     </>
//   );
// }


import React, { useState, useEffect } from 'react';
import {
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Checkbox,
  Button,
  Spinner,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
} from '@chakra-ui/react';
import { Plus, SquarePen, Trash2 } from 'lucide-react';
import { toast } from 'react-toastify';
import Pagination from '../../../utils/pagination/Pagination';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { SolarInverterForm } from './SolarInverterForm';
import { SolarBrandForm } from './SolarBrandForm';
import PanelList from '../panel/PanelList';
import { deleteSolarBrand } from '../../../redux/api/solarBrandApi/SolarbrandApi.js';
import { getSolarBrand } from '../../../redux/reduxApi/SolarBrandReduxApi';
import { deleteSolarBrandAction } from '../../../redux/reduxSlice/SolarBrandSlice.js';
import { getSolarInverter } from '../../../redux/reduxApi/solarInverterReduxApi.js';
import { useSelector, useDispatch } from 'react-redux';
import InverterList from './InverterList.js';
import { formatDate } from '../../../utils/commonFunction/CommonFunction.js';

export default function SolarBrand() {
  const [isSolarInverter, setIsSolarInverter] = useState(false);
  const [isSolarBrand, setIsSolarBrand] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(5);
  const [solarData, setSolarData] = useState([]);
  const [inverterData, setInverterData] = useState([]);
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [itemId, setItemId] = useState("");
  const [dataToEdit, setDataToEdit] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const solarbrandData = useSelector((state) => state.solarBrand.solarBrand);
  const inverterbrandData = useSelector((state) => state.solarInverter.solarInverter);
  const dispatch = useDispatch();
  const [deleteSolarBrandROWID, setDeleteSolarBrandROWID] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(30);

  // For display the inverter data
  useEffect(() => {
    if (inverterbrandData && inverterbrandData.length > 0) {
      setInverterData(inverterbrandData);
    }
  }, [inverterbrandData]);

  useEffect(() => {
    const page = 1;
    dispatch(getSolarInverter(page))
      .then((response) => {
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // For display the solar brand data
  useEffect(() => {
    if (solarbrandData && solarbrandData.length > 0) {
      setSolarData(solarbrandData);
      setData(solarbrandData); // Make sure data state is also updated
    }
  }, [solarbrandData]);

  useEffect(() => {
    const page = 1;
    dispatch(getSolarBrand(page))
      .then((response) => {
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // For Trash modal
  const openTrash = () => {
    setIsOpen(true);
  };

  const closeTrash = () => {
    setIsOpen(false);
  };

  const openSolarInverterDrawer = () => {
    setIsSolarInverter(true);
    setIsUpdateMode(false);
    setDataToEdit({});
  };

  const closeSolarInverter = () => {
    setIsSolarInverter(false);
  };

  const openSolarBrandDrawer = () => {
    setIsSolarBrand(true);
    setIsUpdateMode(false);
    setDataToEdit({});
  };

  const closeSolarBrand = () => {
    setIsSolarBrand(false);
  };

  // FIXED: Bulk delete function
  const handleDelete = () => {
    setShowProgressBar(true);
    setLoading(true);
    
    // Determine which IDs to delete
    const idsToDelete = selectedRows.length > 0 ? selectedRows : [deleteSolarBrandROWID];
    
    // Filter out any undefined or null values
    const validIdsToDelete = idsToDelete.filter(id => id && id !== "");
    
    if (validIdsToDelete.length === 0) {
      toast.error("No items selected for deletion");
      setShowProgressBar(false);
      setLoading(false);
      closeTrash();
      return;
    }

    Promise.all(validIdsToDelete.map((id) => deleteSolarBrand(id)))
      .then(() => {
        // Update local state
        setSolarData(prevData => 
          prevData.filter(item => !validIdsToDelete.includes(item?.ROWID))
        );
        setData(prevData => 
          prevData.filter(item => !validIdsToDelete.includes(item?.ROWID))
        );
        
        // Update Redux store
        dispatch(deleteSolarBrandAction(validIdsToDelete));
        
        // Show success message
        const message = validIdsToDelete.length > 1 
          ? `${validIdsToDelete.length} items deleted successfully` 
          : "Item deleted successfully";
        toast.success(message);
        
        // Refresh data
        dispatch(getSolarBrand(currentPage));
      })
      .catch((error) => {
        console.log("Delete error:", error);
        toast.error("Failed to delete items");
      })
      .finally(() => {
        setShowProgressBar(false);
        setLoading(false);
        closeTrash();
        setSelectedRows([]);
        setDeleteSolarBrandROWID("");
      });
  };

  // FIXED: Single row selection
  const handleRowSelect = (ROWID) => {
    if (!ROWID) return; // Prevent selecting items without ROWID
    
    const isSelected = selectedRows.includes(ROWID);
    let newSelectedRows = [];
    
    if (!isSelected) {
      newSelectedRows = [...selectedRows, ROWID];
    } else {
      newSelectedRows = selectedRows.filter(rowItem => rowItem !== ROWID);
    }
    
    setSelectedRows(newSelectedRows);
    setDeleteId(newSelectedRows.join(','));
  };

  // FIXED: Select all rows
  const handleSelectAllRows = () => {
    const allSelected = selectedRows.length === solarData.length;
    
    if (allSelected) {
      // If all are selected, deselect all
      setSelectedRows([]);
    } else {
      // Select all visible rows on current page
      const currentPageRows = solarData
        .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
        .map(item => item?.ROWID)
        .filter(id => id); // Filter out undefined IDs
      setSelectedRows(currentPageRows);
    }
  };

  // Check if all visible rows are selected
  const isAllVisibleRowsSelected = () => {
    const currentPageRows = solarData
      .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
      .map(item => item?.ROWID)
      .filter(id => id);
    
    return currentPageRows.length > 0 && 
           currentPageRows.every(id => selectedRows.includes(id));
  };

  return (
    <>
      {isLoading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="purple.500" />
        </div>
      )}
      
      <Modal isOpen={isOpen} onClose={closeTrash}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to Delete?</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {selectedRows.length > 0 ? (
              <p>You are about to delete {selectedRows.length} item(s). This action cannot be undone.</p>
            ) : (
              <p>You are about to delete this item. This action cannot be undone.</p>
            )}
          </ModalBody>
          <ModalFooter>
            <Button className='create-button' mr={3} onClick={handleDelete}>
              Delete
            </Button>
            <Button className='cancel-button' onClick={closeTrash}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      
      <Tabs variant="enclosed">
        <TabList>
          <Tab _selected={{ color: 'black', bg: '#C7E9FF', border: "2px solid #AED2EA" }}>Solar Panel Brand </Tab>
          <Tab _selected={{ color: 'black', bg: '#C7E9FF', border: "2px solid #AED2EA" }}>Inverter Brand</Tab>
          <Tab _selected={{ color: 'black', bg: '#C7E9FF', border: "2px solid #AED2EA" }}>Panel List</Tab>
        </TabList>
        
        <TabPanels>
          <TabPanel>
            <div className="d-flex justify-content-end">
              <button className="new-button mx-2" onClick={openSolarBrandDrawer}>
                <Plus size="18px" />
                <span className="ms-1">New</span>
              </button>
            </div>
            
            <div className="custom-scroll leadListConatainer" style={{ maxHeight: "72vh", width: "100%", position: "relative", overflowY: "scroll", overflowX: 'hidden', scrollbarColor: '#A0AEC0 #EDF2F7', scrollbarWidth: '10px' }}>
              <TableContainer className='card card-detail mt-1'>
                <ReactHTMLTableToExcel
                  id="test-table-xls-button"
                  className="download-table-xls-button d-none"
                  table="table-to-xls"
                  filename="SolarBrand List"
                  sheet="tablexls"
                  buttonText="Export"
                />
                <Table id="table-to-xls" className='leadNoPadding' variant='simple' size='sm' stickyHeader style={{ whiteSpace: 'nowrap', backgroundColor: 'white' }}>
                  <Thead>
                    <Tr className="tr-border">
                      <Th className='py-1 th-color' style={{ width: '50px' }}>
                        <Checkbox 
                          isChecked={isAllVisibleRowsSelected()} 
                          onChange={handleSelectAllRows} 
                        />
                      </Th>
                      <Th className='py-1 th-color sticky-column' style={{ width: '80px' }}>Actions</Th>
                      <Th className='py-1 th-color' style={{ width: '150px' }}>Solar Panel Brand Name</Th>
                      <Th className='py-1 th-color' style={{ width: '150px' }}>Solar Panel Brand Description</Th>
                      <Th className='py-1 th-color sticky-column' style={{ width: '80px' }}>Created Time</Th>
                      <Th className='py-1 th-color sticky-column' style={{ width: '80px' }}>Modified Time</Th>
                      <Th className='py-1 th-color sticky-column' style={{ width: '80px' }}>Created By</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {solarData && solarData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((item, idx) => (
                      <Tr className='tr-border' key={idx}>
                        <Td className='font-colors py-1'>
                          <Checkbox 
                            isChecked={selectedRows.includes(item?.ROWID)} 
                            onChange={() => handleRowSelect(item?.ROWID)} 
                          />
                        </Td>
                        <Td className='d-flex' style={{ borderBottom: 'none' }}>
                          <SquarePen 
                            color="#ff176b" 
                            size="16px" 
                            strokeWidth="1" 
                            className='mx-1 cursor-pointer' 
                            onClick={() => { 
                              openSolarBrandDrawer(); 
                              setDataToEdit(item); 
                              setIsUpdateMode(true); 
                              setItemId(item?.ROWID); 
                            }} 
                          />
                          <Trash2 
                            color="#ff176b" 
                            size="16px" 
                            strokeWidth="1" 
                            className='cursor-pointer'
                            onClick={() => { 
                              openTrash(); 
                              setDeleteSolarBrandROWID(item?.ROWID); 
                              setSelectedRows([]); // Clear bulk selection when using single delete
                            }} 
                          />
                        </Td>
                        <Td className='font-colors py-1'>{item?.solarBrandName}</Td>
                        <Td className='font-colors py-1'>{item?.solarBrandDescription}</Td>
                        <Td className='font-colors py-1'>{formatDate(item?.CREATEDTIME)}</Td>
                        <Td className='font-colors py-1'>{formatDate(item?.MODIFIEDTIME)}</Td>
                        <Td className='font-colors py-1'>{item?.createdBy || '-'}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
            </div>
            
            <div className="footer d-flex fixed-bottom start-20">
              <div className="total" style={{ marginLeft: "20%", marginTop: "15px" }}>
                <p className="fw-semibold">Total Count: {solarData.length}</p>
                {selectedRows.length > 0 && (
                  <p className="fw-semibold text-danger">Selected: {selectedRows.length} item(s)</p>
                )}
              </div>
              
              <div className="d-flex align-items-center justify-content-center position-fixed-bottom mx-auto">
                <Pagination
                  totalPages={Math.ceil(solarData.length / itemsPerPage)}
                  onPageChange={(no) => {
                    setCurrentPage(no);
                    setSelectedRows([]); // Clear selection when changing pages
                  }}
                />
              </div>
            </div>
            
            <SolarBrandForm
              isSolarBrand={isSolarBrand}
              closeSolarBrand={closeSolarBrand}
              dataToEdit={dataToEdit}
              isUpdateMode={isUpdateMode}
              setIsUpdateMode={setIsUpdateMode}
              solarInverterId={itemId}
            />
          </TabPanel>

          <TabPanel>
            <InverterList />
          </TabPanel>
          <TabPanel>
            <PanelList />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
}